import Header from '../components/Header';
import Menu from '../components/Menu';
import { useState } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

export default function Dashboard() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      <Header logged="true" drawerToggle={handleDrawerToggle} />
      <Menu mobileOpen={mobileOpen} drawerToggle={handleDrawerToggle} />
      <Box sx={{ marginLeft: { sm: '240px' }, paddingTop: '74px' }}>
        <Outlet />
      </Box>
    </>
  );
}
